<div class="rbac-tab">
  <p-tabMenu [model]="items" [activeItem]="activeItem"></p-tabMenu>
</div>
<router-outlet></router-outlet>
